<template>
  <v-application v-if="access.item_print_label">
    <v-card width="1500" class="ma-2">
      <v-card-text>
        <v-layout row class="ma-2">
          <v-flex md6 px-2>
            <v-select
              :label="$t('label_type')"
              v-model="default_type"
              :items="[
                {
                  text: '1. A4 sheet - 70 mm x 37 mm',
                  type: 1,
                },
                {
                  text: '2. A4 sheet - 70 mm x 29.7 mm',
                  type: 2,
                },
                {
                  text: '3. A4 sheet - 52.5 mm x 29.7 mm',
                  type: 3,
                },
                {
                  text: '4. A4 sheet - 35 mm x 29.7 mm',
                  type: 4,
                },
                {
                  text: '5. A4 sheet - 30 mm x 19.8 mm without code',
                  type: 11,
                },
                {
                  text: '6. Godex Printer Label - 90 mm x 38 mm',
                  type: 5,
                },
                {
                  text: '7. Godex Printer Label - 58 mm x 36 mm',
                  type: 8,
                },
                {
                  text: '8. Multi Pricing Godex Printer Label - 90mm x 38 mm',
                  type: 6,
                },
                {
                  text: '9. Label 4X - 4 x 20mm x 40 mm',
                  type: 7,
                },
                {
                  text: '10. A4 sheet - 33 x 70 mm x 26.1 mm',
                  type: 9,
                },
                {
                  text: '11. A4 sheet - QRCode 52.5 mm x 29.7 mm',
                  type: 10,
                },
                {
                  text: '12. Printer TSC - 40 mm x 58 mm',
                  type: 12,
                },
                {
                  text: '13. Godex Printer Label - 58 mm x 36 mm',
                  type: 13,
                },
                {
                  text: '14. Godex Printer Label - 65 mm x 40 mm',
                  type: 14,
                },
                {
                  text: '15. Godex Printer Label - 55 mm x 30 mm',
                  type: 15,
                },
                {
                  text: '16. Xp-350B - 55 mm x 30 mm',
                  type: 16,
                },
                {
                  text: '17. A4 sheet - 70 mm x 40 mm',
                  type: 17,
                },
                {
                  text: '18. Godex Printer Label - 58 mm x 40 mm',
                  type: 18,
                },
                {
                  text: '19. Godex Printer Label - 4 x 20 mm x 40 mm',
                  type: 19,
                },
                {
                  text: '20. Godex Printer Label - 20 mm x 30 mm',
                  type: 20,
                },
                {
                  text: '21. Godex Printer Label - 58 mm x 36 mm without shtrix',
                  type: 21,
                },
                {
                  text: '22. CST - 30 mm x 40 mm',
                  type: 22,
                },
                {
                  text: '23. CST - 30 mm x 40 mm QRCode',
                  type: 23,
                },
                {
                  text: '24. A4 with logo',
                  type: 24,
                },
                {
                  text: '25. Multi Pricing Godex Printer Label - 90mm x 38 mm',
                  type: 25,
                },
                {
                  text: '26. Test',
                  type: 26,
                },
                {
                  text: '27. Godex Printer Label - 58 mm x 36 mm',
                  type: 27,
                },

                {
                  text: '28. 30 mm x 20 mm',
                  type: 28,
                },
                {
                  text: '29. Godex Printer Label - 58 mm x 36 mm',
                  type: 29,
                },
                {
                  text: '30. Multi Pricing Godex Printer Label - 58 mm x 38 mm',
                  type: 31,
                },
              ]"
              item-value="type"
              item-text="text"
            />
          </v-flex>
          <v-flex md6 px-2>
            <v-select
              v-model="current_service"
              item-text="name"
              item-value="_id"
              :label="$t('store')"
              :items="services"
              :disabled="typeof items == typeof [] && items.length > 0"
            />
          </v-flex>
        </v-layout>

        <v-layout class="ma-2">
          <v-flex md6 px-2>
            <v-select
              v-model="current_type"
              :label="$t('barcode_source_field')"
              :items="types"
            />
          </v-flex>
        </v-layout>
        <v-layout row class="ma-2">
          <v-flex md3 px-2>
            <v-checkbox v-model="print_name" :label="$t('print_name')" />
          </v-flex>
          <v-flex md3 px-2>
            <v-checkbox v-model="print_price" :label="$t('print_price')" />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card width="1500" class="ma-2 mt-5">
      <v-card-title px-2>
        {{ $t("items") }}
        <v-spacer />
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="date"
          persistent
          width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-flex md2>
              <v-text-field
                v-model="date"
                :label="$t('auto_fill')"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-flex>
          </template>
          <v-date-picker v-model="date" v-bind:max="maxDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
            <v-btn text color="primary" @click="autoFillItems">OK</v-btn>
          </v-date-picker>
        </v-dialog>
        <v-btn text color="primary" @click="byDialog(1)">{{
          $t("add_by_category")
        }}</v-btn>
        <v-btn text color="primary" @click="byDialog(2)">{{
          $t("add_by_supplier")
        }}</v-btn>
        <v-btn
          v-if="!last_clicked && count_not_priced"
          text
          :color="count_not_priced ? 'error' : 'primary'"
          @click="printedItemsGet"
        >
          {{ $t("last_priced_goods") }} ({{ count_not_priced }})
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          hide-default-footer
          no-data-text="You have not selected items yet"
          :items-per-page="200000"
        >
          <template #[`item.name`]="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle class="grey--text"
                >SKU {{ item.sku }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template #[`item.quality`]="{ item }">
            <v-text-field
              :rules="[rules.required]"
              v-model="item.quality"
              reverse
              autocomplete="off"
              type="number"
              @focus="$event.target.select()"
            />
          </template>
          <template #[`item.remove`]="{ item }">
            <v-btn icon v-on:click="remove_item(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-divider />
        <v-card-text>
          <v-autocomplete
            v-model="item"
            :hint="items.length == 0 ? $t('please_add_at_least_one_item') : ''"
            label="Search item"
            :loading="loading"
            multi-line
            item-text="search_text"
            hide-no-data
            v-bind:items="items_list"
            return-object
            v-on:change="add_item"
            persistent-hint
            v-on:update:search-input="getItems"
          >
            <template #append>
              <v-icon></v-icon>
            </template>
            <template #item="data">
              <v-list-item-content>
                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                <v-list-item-subtitle
                  >SKU {{ data.item.sku }}</v-list-item-subtitle
                >
                <v-list-item-subtitle v-if="data.item.barcode">
                  Barcode
                  <span v-for="(barcode, ind) in data.item.barcode" :key="ind"
                    >{{ barcode + ", " }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
      </v-card-text>
    </v-card>

    <v-card width="1500" class="ma-2 mt-5 mb-10" color="transparent" flat>
      <hr class="my-4" />
      <v-layout row mx-2 width="800">
        <hr />
        <v-flex md12>
          <v-layout row>
            <v-spacer />
            <v-btn tile class="mx-4" @click="cancelClicked">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn tile color="success" ml-2 @click="createLabel"
              ><div class="text-color">{{ $t("create_labels") }}</div>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <v-snackbar v-model="snackbar" right top :timeout="3000" color="red"
      >Unable to create labels. Please fix the errors and try again.</v-snackbar
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text"
          >This item has already been added</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="by_dialog" persistent width="600">
      <v-card tile>
        <v-card-title>{{ by_dialog_items.title }}</v-card-title>
        <hr style="border: 0.5px dashed grey" />
        <v-layout row mx-4>
          <v-text-field
            v-model="search_item"
            autocomplete="off"
            color="black"
            placeholder="Search"
            @input="searchItems"
            prepend-icon="mdi-magnify"
            :loading="data_loading"
          ></v-text-field>
        </v-layout>

        <hr style="border: 0.5px dashed grey" class="mt-0" />
        <v-card-text class="py-2 px-4">
          <v-layout row v-for="(itm, ind) in by_dialog_items.items" :key="ind">
            <v-flex md12 px-4>
              <v-layout>
                <v-flex md12>
                  <v-checkbox
                    :label="itm.name"
                    v-model="by_dialog_items.selected[ind]"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md12>
                  <hr
                    v-if="by_dialog_items.items.length - 1 != ind"
                    style="border: 0.5px dashed grey"
                    class="mt-0"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>

        <hr
          v-if="by_dialog_items.items.length > 0"
          style="border: 0.5px dashed grey"
          class="mt-0"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="by_dialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="addItem">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../mixins/services";
export default {
  name: "Items",
  mixins: [Services],
  data: () => ({
    print_name: true,
    print_price: true,
    dialog: false,
    by_dialog: false,
    by_dialog_items: {
      title: "Add items by category",
      items: [],
      old_items: [],
      selected: [],
    },
    default_type: 4,
    data_loading: false,
    snackbar: false,
    headers: [
      { text: "Item", value: "name", align: "left" },
      { text: "Quantity", value: "quality", align: "right", width: 80 },
      { text: null, value: "remove", align: "right", width: 50 },
    ],
    rules: {
      required: (value) => !!value || "",
    },
    data: [],
    stocks: [
      { text: "All items", value: "all" },
      { text: "Low stock", value: "low" },
      { text: "Out of stock", value: "out" },
    ],
    stock: null,
    page: 1,
    loading: false,
    numPages: 1,
    total: 0,
    items: [],
    item: {},
    items_list: [],
    current_type: "sku",
    current_type_id: 1,
    current_service: null,
    types: ["sku", "barcode"],
    search_item: "",
    search_text: "123",
    err: null,
    date: null,
    maxDate: new Date().toISOString().substr(0, 10),
    modal: false,
    count_not_priced: 0,
    last_clicked: false,
  }),
  watch: {
    services() {
      if (this.services && this.services.length > 0) {
        localStorage.setItem(
          "emailed_receipt",
          this.services[0]?.settingReceipt?.emailed_receipt
        );
        localStorage.setItem(
          "printed_receipt",
          this.services[0]?.settingReceipt?.printed_receipt
        );
        if (this.target == "label") {
          this.current_service = this.services[0]?._id;
        }
      }
    },
    current_service() {
      this.getItems(this.search_text, true);
      this.countNotPrintedItems();
      this.refreshItems();
    },
    default_type() {
      this.$store.commit("setLastLabel", this.default_type);
    },
  },
  computed: {
    query() {
      return this.$route.query;
    },
    target() {
      return this.$route.params["target"];
    },
  },
  methods: {
    // autoFill() {
    //   $refs.dialog.save(date)
    // },
    async countNotPrintedItems() {
      const params = {
        service_id: this.current_service,
      };
      const result = this.$communicator.then(
        this,
        await this.$communicator("printed_item_count", {
          params,
        })
      );
      if (result) {
        this.count_not_priced = result.count;
      }
    },
    async autoFillItems() {
      if (!this.date) {
        return;
      }
      this.$refs.dialog.save(this.date);
      const result = this.$communicator.then(
        this,
        await this.$communicator("print_labels_auto_fill_by_date", {
          params: {
            service: this.current_service ? this.current_service : "",
            date: new Date(this.date).getTime(),
          },
        })
      );
      if (result instanceof Array) {
        const itemMap = {};
        const items = [];
        for (const it of this.items) {
          if (!itemMap[it._id]) {
            itemMap[it._id] = it;
            items.push(it);
          }
        }
        for (const it of result) {
          if (!itemMap[it._id]) {
            itemMap[it._id] = it;
            it.quality = 1;
            items.push(it);
          }
        }

        this.items = items;
      }
    },
    searchItems() {
      var items = [];
      for (let i = 0; i < this.by_dialog_items.old_items.length; i++) {
        if (
          new RegExp(this.search_item.trim(" "), "ig").exec(
            this.by_dialog_items.old_items[i].name
          )
        ) {
          items.push(this.by_dialog_items.old_items[i]);
        }
      }
      this.by_dialog_items.items = items;
    },
    async addItem() {
      var categories = [];
      for (let i = 0; i < this.by_dialog_items.selected.length; i++) {
        if (this.by_dialog_items.selected[i]) {
          categories.push(this.by_dialog_items.items[i]._id);
        }
      }
      var params = {
        categories: categories,
      };
      if (this.current_type_id == 2) {
        params = {
          suppliers: categories,
        };
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          params: {
            ...params,
            service: this.current_service ? this.current_service : "",
          },
        })
      );
      for (let j = 0; j < items.length; j++) {
        var has = false;
        for (let i = 0; i < this.items.length; i++) {
          if (items[j]._id == this.items[i]._id) {
            has = true;
          }
        }
        if (!has) {
          items[j].quality = 1;
          this.items.push(this.$copy(items[j]));
        }
      }
      this.by_dialog = false;
    },
    async byDialog(ind) {
      this.current_type_id = ind;
      this.data_loading = true;
      if (ind == 1) {
        try {
          this.by_dialog_items.items = (
            await this.$communicator("list_of_categories")
          ).data.data;
          this.by_dialog_items.old_items = this.by_dialog_items.items;
        } catch (err) {
          this.err = err;
        }
        this.by_dialog_items.title = "Add items by category";
      } else {
        try {
          var items = (await this.$communicator("all_suppliers")).data.data;
          for (let i = 0; i < items.length; i++) {
            items[i].name = items[i].supplier_name;
          }
          this.by_dialog_items.items = items;
          this.by_dialog_items.old_items = this.by_dialog_items.items;
        } catch (err) {
          this.err = err;
        }
        this.by_dialog_items.title = "Add items by supplier";
      }
      this.by_dialog = true;
      this.data_loading = false;
    },
    cancelClicked() {
      this.$router.go(-1);
    },
    async setPrintedTime(service_id, items) {
      const item_ids = [];
      for (const it of items) {
        item_ids.push(it._id);
      }
      const params = {
        service_id: service_id,
        items: item_ids,
      };
      this.$communicator.then(
        this,
        await this.$communicator("set_printed_time", {
          params,
        })
      );
    },
    async createLabel() {
      var show_snackbar = false;
      for (let i = 0; i < this.items.length; i++) {
        if (typeof this.items[i].prices != typeof []) {
          this.items[i].prices = [];
        }
        if (typeof this.items[i].price != typeof 5) {
          this.items[i].price = 0;
        }
        const prices = [];
        // first
        if (this.items[i].prices.length > 0) {
          prices.push(this.items[i].prices[0]);
        } else {
          prices.push({ from: 0, price: this.items[i].price });
        }
        // second
        if (this.items[i].prices.length > 1) {
          prices.push(this.items[i].prices[1]);
        } else {
          prices.push({ from: 0, price: this.items[i].price });
        }
        // third
        if (this.items[i].prices.length > 2) {
          prices.push(this.items[i].prices[2]);
        } else {
          prices.push({ from: 0, price: this.items[i].price });
        }

        if (this.items[i].quality == "") {
          show_snackbar = true;
        }
        if (this.current_type == "sku") {
          this.items[i].code = this.items[i].sku + "";
        } else if (this.current_type == "barcode") {
          this.items[i].code =
            this.items[i].barcode && this.items[i].barcode.length > 0
              ? this.items[i].barcode[0] + ""
              : "";
        }
        if (
          this.items[i].code &&
          this.items[i].code.length < 13 &&
          this.default_type == 22
        ) {
          this.items[i].code = this.items[i].code.slice(-13);
        }
        if (
          typeof this.items[i].barcode == typeof [] &&
          this.items[i].barcode.length > 0
        ) {
          this.items[i].barcode = this.items[i].barcode[0];
        } else {
          this.items[i].barcode = "";
        }
        if (this.print_name == false) {
          this.items[i].name = null;
        }
        if (this.print_price == false) {
          this.items[i].price = null;
        }
      }
      if (this.items.length == 0 || show_snackbar) {
        this.snackbar = true;
      } else {
        for (const s of this.services) {
          if (this.current_service == s._id) {
            this.$store.commit("setService", s.name);
          }
        }
        await this.setPrintedTime(this.current_service, this.items);
        this.$communicator.printLabelAll(this.items, this.default_type);
      }
    },
    add_item() {
      var has_account = false;
      for (let i = 0; i < this.items.length; i++) {
        if (this.item._id == this.items[i]._id) {
          has_account = true;
        }
      }
      if (has_account) {
        this.dialog = true;
      } else {
        this.item.quality = 1;
        this.items.push(this.$copy(this.item));
      }
      this.item = {};
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    changePagination(page) {
      this.page = page;
      this.update_items();
    },
    async remove(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("remove_items", {
        params: {
          indexes: indices,
        },
      });
      this.update_items();
    },
    async getItems(search, service_changed) {
      if (typeof search != typeof "invan") {
        search = "";
      }
      if (this.search_text == search && !service_changed) {
        return;
      }
      this.search_text = search;
      this.loading = true;
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_inv_items", {
          arguments: [50, 1],
          params: {
            service: this.current_service ? this.current_service : "",
            search: search,
          },
        })
      );

      if (items && items instanceof Array) {
        const items_list = [];
        for (let it of items) {
          let search_text = it.name + this.converter(it.name) + it.sku;
          if (typeof it.barcode == typeof []) {
            for (const b of it.barcode) {
              search_text += b;
            }
          }
          it = this.$copy(it);
          items_list.push({
            ...it,
            search_text: search_text,
          });
        }
        this.items_list = items_list;
      }

      this.loading = false;
    },
    async checkQuery() {
      if (this.query) {
        if (this.query.purchase != undefined) {
          const data = this.$communicator.then(
            this,
            await this.$communicator("purchase_by_id", {
              arguments: [this.query.purchase],
            })
          );
          if (data && typeof data.items == typeof []) {
            const items = [];
            const exist = {};
            for (const item of data.items) {
              if (exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length;
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  category: item.category,
                  category_name: item.category_name,
                });
              } else {
                items[exist[item.product_id]].quality += item.quality;
              }
            }
            this.items = items;
            this.current_service = data.service;
          }
        } else if (this.query.transfer != undefined) {
          const transfer = this.$communicator.then(
            this,
            await this.$communicator("transfer", {
              arguments: [this.query.transfer],
            })
          );
          if (transfer && typeof transfer.items == typeof []) {
            const items = [];
            const exist = {};
            for (const item of transfer.items) {
              if (exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length;
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  category: item.category,
                  category_name: item.category_name,
                });
              } else {
                items[exist[item.product_id]].quality += item.quality;
              }
            }
            this.items = items;
            this.current_service = transfer.second_service;
          }
        } else if (this.query.stock != undefined) {
          const stock = this.$communicator.then(
            this,
            await this.$communicator("stock_by_id", {
              arguments: [this.query.stock],
            })
          );
          if (stock && typeof stock.items == typeof []) {
            const items = [];
            const exist = {};
            for (const item of stock.items) {
              if (exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length;
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.changed,
                  price: item.price,
                  category: item.category,
                  category_name: item.category_name,
                });
              } else {
                items[exist[item.product_id]].quality += item.quality;
              }
            }
            this.items = items;
            this.current_service = stock.service;
          }
        } else if (this.query.production != undefined) {
          const production = this.$communicator.then(
            this,
            await this.$communicator("production_by_id", {
              arguments: [this.query.production],
            })
          );
          if (production && typeof production.items == typeof []) {
            const items = [];
            const exist = {};
            for (const item of production.items) {
              if (exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length;
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  category: item.category,
                  category_name: item.category_name,
                });
              } else {
                items[exist[item.product_id]].quality += item.quality;
              }
            }
            this.items = items;
            this.current_service = production.service;
          }
        }
        this.refreshItems(this.items);
      }
    },
    async refreshItems(itemIds) {
      if (!itemIds) return;
      const ids = [];
      for (const itm of itemIds) {
        if (itm._id) {
          ids.push(itm._id);
        }
        if (itm.product_id) {
          ids.push(itm.product_id);
        }
      }

      this.items = [];
      if (!this.current_service) return;
      const items = this.$communicator.then(
        this,
        await this.$communicator("inv_items_refresh", {
          params: {
            service: this.current_service,
            indexes: ids,
          },
        })
      );

      if (items instanceof Array) {
        const ITEMS = [];
        const resMap = {};
        for (const it of items) {
          resMap[it._id] = it;
        }
        for (const it of itemIds) {
          if (resMap[it._id]) {
            const currentItem = {};
            if (!(resMap[it._id].prices instanceof Array)) {
              resMap[it._id].prices = [];
            }
            if (resMap[it._id].prices.length > 0) {
              currentItem.from1 = resMap[it._id].prices[0].from;
              currentItem.price1 = resMap[it._id].prices[0].price;
            }

            if (resMap[it._id].prices.length > 1) {
              currentItem.from2 = resMap[it._id].prices[1].from;
              currentItem.price2 = resMap[it._id].prices[1].price;
            }

            if (resMap[it._id].prices.length > 2) {
              currentItem.from3 = resMap[it._id].prices[2].from;
              currentItem.price3 = resMap[it._id].prices[2].price;
            }

            ITEMS.push({
              ...it,
              ...currentItem,
              prices: resMap[it._id].prices,
              category: resMap[it._id].category,
              category_name: resMap[it._id].category_name,
            });
          }
        }

        this.items = ITEMS;
      }
    },
    async printedItemsGet() {
      const items = this.$communicator.then(
        this,
        await this.$communicator("printed_item_get", {
          params: {
            service_id: this.current_service,
          },
        })
      );
      if (!(items instanceof Array)) {
        return;
      }
      const items_list = [];
      for (const item of items) {
        items_list.push({
          ...item,
          quality: 1,
        });
      }
      this.items = items_list;
      this.last_clicked = true;
    },
  },
  async mounted() {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.stock = this.stocks[0];
    await this.checkQuery();
    this.getItems();
  },
  beforeMount() {
    this.default_type = this.$store.state.lastLabel;
    this.access = this.$store.state.access;
  },
};
</script>
